import { create } from 'zustand'

interface CustomResultStore {
    isOpened: boolean
    updateIsOpened: (isOpened: boolean) => void
}

export const useCustomResultStore = create<CustomResultStore>((set) => ({
    isOpened: false,
    updateIsOpened: (isOpened: boolean) => {
        set(() => ({ isOpened }))
    },
}))
